/* global $ */

export const videoHandler = () => {
  let currentID = 1;
  $.$body.find('.videoWrapper iframe').each(function() {
    $(this).attr('id', currentID);
    $(this).attr('src', $(this).attr('src') + '&autoplay=0');
    $(this).attr('src', $(this).attr('src') + '&rel=0');
    currentID++;
  });

  let current = 1;
  $.$body.find('.video-cover').each(function() {
    const findVideo = $('#' + current);
    $(this).on('click', function() {
      $(this).fadeOut();
      $(findVideo).attr(
        'src',
        $(findVideo)
          .attr('src')
          .replace('autoplay=0', 'autoplay=1'),
      );
    });
    current++;
  });
};

videoHandler();

// helper function for wysiwyg embed videos
// makes videos responsive and full width of container
$.$body.find('.wysiwyg-text iframe').each(function() {
  const $this = $(this);
  // check if youtube link
  if ($this.attr('src').includes('youtube.com')) {
    $($this).wrap(() => `<div class="videoWrapper">${$this}</div>`);
  }
});

// $.$body.find('.pop-over .videoWrapper iframe').each(function() {
//   $(this).attr('id', currentID);
//   $(this).attr('src', $(this).attr('src') + '&autoplay=1');
//   $(this).attr('src', $(this).attr('src') + '&rel=0');
//   currentID++;
// });
//
// $(document).on('click touchstart', (event) => {
//   if (!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
//     if ($('.pop-over').is(':visible')) {
//       $('.pop-over').hide();
//       const iFrameSrc = $('.pop-over .videoWrapper iframe').attr('src');
//       if (iFrameSrc) {
//         $('.pop-over .videoWrapper iframe').attr(
//           'src',
//           iFrameSrc.replace('autoplay=1', 'autoplay=0'),
//         );
//       }
//     }
//   }
// });
//
// $.$body.find('.play-button').click((event) => {
//   if (!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
//     if ($('.pop-over').is(':visible')) {
//       $('.pop-over').hide();
//     }
//   }
// });

// prevent ambient video from being played by default, saving data.
function playVideo($video) {
  $video
    .prop('autoplay', true)
    .attr('preload', 'auto')
    .removeClass('unplayed');
  const video = $video.get(0);
  if (video && typeof video.play === 'function') {
    video.play();
  }
}

const $videos = $('body').find('video');
function playVideosIfVisible() {
  if ($videos.filter('.unplayed').length) {
    $('body')
      .find('video')
      .filter('.unplayed')
      .each((i, el) => {
        const $video = $(el);
        if ($video.css('display') === 'block') {
          playVideo($video);
        }
      });
  } else {
    $(window).off('resize', playVideosIfVisible);
  }
}

if ($videos.length) {
  $(window).resize(playVideosIfVisible);
  playVideosIfVisible();
}

// load ambient videos lazily
document.addEventListener('DOMContentLoaded', () => {
  const lazyVideos = Array.from(document.querySelectorAll('video.lazy'));

  if ('IntersectionObserver' in window) {
    const lazyVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((video) => {
        const { target } = video;
        if (video.isIntersecting) {
          Array.from(target.children).forEach((videoSource) => {
            // console.log(videoSource);
            if (
              typeof videoSource.tagName === 'string' &&
              videoSource.tagName === 'SOURCE'
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          });
          target.preload = 'auto';
          target.autoplay = true;
          target.load();
          target.classList.remove('lazy');
          target.classList.remove('unplayed');

          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    // console.log(lazyVideos);

    lazyVideos.forEach((lazyVideo) => {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

// show yt videos on click
$.$body.on('click', '.js-start-video', (e) => {
  const $container = $(e.currentTarget);
  const isOverlay = $container.hasClass('faux-video-overlay');
  const isCoverImage = $container.hasClass('cover-image');
  const hasMobile =
    isCoverImage && $container.parent().find('.fv-mobile').length;
  const isMobile =
    $container.hasClass('fv-mobile') || (hasMobile && window.innerWidth < 768);
  let classes = 'clicked playing';

  if (isOverlay) {
    classes += ' from-overlay';
  }

  const iframeWindow = isOverlay
    ? $container
        .parent()
        .addClass(classes)
        .find('iframe')
        .get(0)
    : $container
        .parent()
        .addClass(classes)
        .find(
          `.fv-embed-container.${isMobile ? 'fv-mobile' : 'fv-desktop'} iframe`,
        )
        .get(0);

  console.log('playing', iframeWindow, isMobile);

  iframeWindow.contentWindow.postMessage(
    JSON.stringify({
      event: 'command',
      func: 'playVideo',
      args: [],
    }),
    '*',
  );
});
